"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyUtil = void 0;
const clvm_1 = require("clvm");
const __1 = require("..");
const derive_keys_1 = require("./derive_keys");
const mnemonic_1 = require("./mnemonic");
const synthetic_key_1 = require("./synthetic_key");
class KeyUtil {
    constructor() {
        this.impl = derive_keys_1.DeriveKeysUtils;
        this.mnemonic = mnemonic_1.MnemonicUtils;
        this.synthetic = synthetic_key_1.SyntheticKeyUtil;
    }
    hexToPrivateKey(hex) {
        const { PrivateKey } = (0, clvm_1.getBLSModule)();
        const pkHex = __1.Util.address.validateHashString(hex);
        if (pkHex === "") {
            return null;
        }
        return PrivateKey.from_bytes(Buffer.from(pkHex, "hex"), false);
    }
    privateKeyToHex(pk) {
        return Buffer.from(pk.serialize()).toString("hex");
    }
    masterSkToWalletSk(sk, index) {
        const { PrivateKey } = (0, clvm_1.getBLSModule)();
        if (typeof sk === "string") {
            sk = this.hexToPrivateKey(sk);
        }
        if (!(sk instanceof PrivateKey)) {
            return null;
        }
        return derive_keys_1.DeriveKeysUtils.masterSkToWalletSk(sk, index);
    }
    masterSkToWalletSkUnhardened(sk, index) {
        const { PrivateKey } = (0, clvm_1.getBLSModule)();
        if (typeof sk === "string") {
            sk = this.hexToPrivateKey(sk);
        }
        if (!(sk instanceof PrivateKey)) {
            return null;
        }
        return derive_keys_1.DeriveKeysUtils.masterSkToWalletSkUnhardened(sk, index);
    }
    hexToPublicKey(hex) {
        const { G1Element } = (0, clvm_1.getBLSModule)();
        let ok = hex.length === 96;
        for (let i = 0; i < hex.length && ok; ++i) {
            if (!"abcdef0123456789".includes(hex[i].toLowerCase())) {
                ok = false;
            }
        }
        if (!ok) {
            return null;
        }
        return G1Element.from_bytes(Buffer.from(hex, "hex"));
    }
    publicKeyToHex(pk) {
        return Buffer.from(pk.serialize()).toString("hex");
    }
    masterPkToWalletPk(pk, index) {
        const { G1Element } = (0, clvm_1.getBLSModule)();
        if (typeof pk === "string") {
            pk = this.hexToPublicKey(pk);
        }
        if (!(pk instanceof G1Element)) {
            return null;
        }
        return derive_keys_1.DeriveKeysUtils.masterPkToWalletPkUnhardened(pk, index);
    }
}
exports.KeyUtil = KeyUtil;
//# sourceMappingURL=index.js.map